import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-payment-success-01',
  standalone: true,
  templateUrl: '../../assets/payment-success-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPaymentSuccess01Icon {}
